import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const AffiliateHome = lazyRouteComponent(() => import('../pages/affiliate-home'))

export const affiliateHomeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/affiliate/$affiliate',
  component: AffiliateHome,
})
